/** Versioned completion opens its own saved page; older notifications keep their project destination. */
export function reviewCompletionDestination(notification) {
    if (notification.type !== 'client_review_done')
        return null;
    const value = notification.data.clientReviewVersion?.exactUrl;
    if (!value)
        return null;
    try {
        return /^https?:$/.test(new URL(value).protocol) ? value : null;
    }
    catch {
        return null;
    }
}
/**
 * Derive the notification category from its type.
 * Shared between server (insert) and extension (badge computation).
 */
export function deriveCategory(type) {
    if (type === 'client_note' || type === 'client_review_done')
        return 'alert';
    return 'activity';
}
/** Bell sentence for client_review_done, shared so the dashboard and extension cannot drift. */
export function clientReviewDoneSentence(name, commentCount) {
    const who = name || 'A client';
    const n = commentCount ?? 0;
    if (n <= 0)
        return `${who} finished\u00a0reviewing`;
    // Non-breaking spaces keep "reviewing (3 comments)" together, so a wrap never
    // strands "comments)" alone on the bell's second line.
    return `${who} finished\u00a0reviewing\u00a0(${n}\u00a0${n === 1 ? 'comment' : 'comments'})`;
}
export const inboxKey = (item) => `${item.source}:${item.id}`;
export const inboxRef = (item) => ({ source: item.source, id: item.item.id });
/** Apply confirmed changes to the current list, preserving concurrent arrivals. */
export function applyInboxResult(items, source, result) {
    const changed = new Set(result.items.filter(i => i.source === source).map(i => i.id));
    const gone = new Set(result.unavailable.filter(i => i.source === source).map(i => i.id));
    return items.filter(i => !gone.has(i.id) && !(result.action === 'delete' && changed.has(i.id)))
        .map(i => changed.has(i.id) ? { ...i, isRead: result.action === 'read' } : i);
}
//# sourceMappingURL=notifications.js.map